import React from 'react';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';
import cn from 'classnames';

const EditRubricConfirmEditButtonIcon: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5 13L9 17L19 7"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditRubricConfirmEditButton: React.FC<{
  onClick: () => void;
  disabled: boolean;
}> = ({ onClick, disabled }) => {
  const language = useLanguage();
  return (
    <TouchTarget
      disabled={disabled}
      behavior={{
        type: 'onClick',
        onClick,
      }}
      label={language.rubricConfirmEditLabel()}
      content={({ hovered, disabled }) => (
        <div
          className={cn(
            'w-12 h-12 rounded-full bg-white shadow-12px flex items-center justify-center text-gray-900',
            {
              'brightness-75': hovered,
              'brightness-50': disabled,
            },
          )}
        >
          <EditRubricConfirmEditButtonIcon />
        </div>
      )}
    />
  );
};
